import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function hashParams(rawHash: string): URLSearchParams {
  const withoutHash = rawHash.replace(/^#/, "");
  if (!withoutHash) return new URLSearchParams();

  // Case 1: base recovery links from Supabase: #access_token=...&type=recovery
  if (!withoutHash.startsWith("/")) {
    return new URLSearchParams(withoutHash);
  }

  // Case 2: HashRouter route with query: #/reset-password?type=recovery
  const queryIndex = withoutHash.indexOf("?");
  if (queryIndex === -1) return new URLSearchParams();
  return new URLSearchParams(withoutHash.slice(queryIndex + 1));
}

export default function PasswordRecoveryReturnHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.pathname === "/reset-password") return;

    const search = new URLSearchParams(location.search);
    const hash = hashParams(window.location.hash || "");

    const type = search.get("type") || hash.get("type");
    if (type !== "recovery") return;

    const params = new URLSearchParams();
    for (const [key, value] of hash.entries()) params.set(key, value);
    for (const [key, value] of search.entries()) params.set(key, value);

    const qs = params.toString();
    navigate(qs ? `/reset-password?${qs}` : "/reset-password", { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
